import React, {useEffect, useState} from "react"
import { Card, CardBody, Table, Col, CardTitle } from "reactstrap"
import { get } from "lodash"
import axios from "axios";
import {API_URL} from "../../../constants/constants";
export default function Messages(props) {
  const [sms_logs, setSmsLogs] = useState([])
  // const sms_logs = get(props, "userData.sms_logs", [])
  useEffect(() => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/sms-logs?mobile_number=${props.userData.phone_number}`,
    })
      .then(function (response) {
        setSmsLogs(response?.data?.data)
      })
      .catch(function (response) {})
  }, [props.userData.phone_number])
  return (
      <>
      <Col lg={6}>
      </Col>
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Messages</CardTitle>

          <div className="row mb-4">
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-nowrap">Created Date</th>
                      <th className="text-nowrap">Message Type</th>
                      <th className="text-nowrap">Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sms_logs?.map((sms, i) => (
                      <>
                        <tr key={i}>
                          <td>
                            {new Date(
                              Date.parse(sms?.created_at)
                            ).toLocaleDateString('en-GB')}
                          </td>
                          <td>{sms?.direction}</td>
                          <td>{sms?.message}</td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </Table>
              </div>
              {/* <p className="text-muted fw-medium col-form-label">
                No Available Messages
              </p> */}
            </Col>
          </div>
        </CardBody>
      </Card>
    </Col>
      </>
  )
}
